export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00967.c10a039a.png";